import * as React from "react";
import { Table } from "./Table";
import { DivisionWiseTable } from "./DivisionWiseTable";
// import "rsuite/dist/styles/rsuite-default.css";
import "./Pricing.scss";
import {
  UpdateBrandCost,
  submitBCI,
  UpdateSaveReason,
  getPricingCustomerList,
  getPricingDivsionDataByCustomer,
  getPricingMonthlyTrend,
  savePricingExecutedPrice,
  getTotalPageNumber,
  updatePricingDataRec,
  getAPI,
  getPricingCustomerClass,
  getPricingForItemsListTemp,
  updateExecutedPrice,
  rejectExecutedPrice,
} from "../../queries/apiQueries";
import {
  Content,
  Row,
  Col,
  // Alert,
  Button,
  SelectPicker,
  Loader,
  Toggle,
  CheckPicker,
  Checkbox,
} from "rsuite";
import { MonthlyTrendGraph } from "./MonthlyTrendGraph";
import Title from "./Title";
import { numberFormatter } from "../../utils";
import { Filter } from "../../components/common/filter";
import { Box, Modal } from "@mui/material";
// import { appInsights } from "../../pages/Router";
import { BubbleScatterWithZoom } from "./BubbleScatterWithZoom";
import DivisionData from "./DivisionData";
import { RangeSlider } from "rsuite";
import Filters from "./Filters";

export default class Pricing extends React.Component<any, any> {
  mainData: any = [];
  clickedItem: any;
  clickedItemDesc: any;
  weeksData: any;
  selectedProductType: any;
  changesObj: any = {};
  fiscalWeek: any;
  changesObjRec: any = {};
  categoryFilterValue: any = [];
  tableDataBackup: any = [];
  pricingFilterData: any;
  selectedPC: any;
  debounceTimeoutId: any = null;
  weekFilterValue: any = [];
  categoryDefault: any = ["Dairy and Processed Potatoes"];
  divisionDefault: any = [];
  weekDefault: any = "";
  selectedCustomer: any;
  selectedCustomerDetailsItem: any;
  footerStyles = {
    padding: "10px 2px",
    borderTop: "1px solid #e5e5e5",
  };

  footerButtonStyle = {
    float: "right",
    marginRight: 10,
    marginTop: 2,
  };
  fieldMatchColumns: any = {
    "Product Type": "productType",
    "Item Type": "itemId",
    Volume: "vol",
    Revenue: "rev",
    Opportunity: "opport",
  };
  sortObj = {
    field: "opport",
    isAsc: false,
  };
  nrData: any = [];
  clickedTableRow: any;
  execPriceResponse = new Map();
  constructor(props: any) {
    super(props);
    this.state = {
      userEmail: localStorage.getItem('user_email'),
      pageLoading: false,
      divisionData: [],
      itemExecPrice: 0,
      itemData: [],
      itemId: "",
      itemDesc: "",
      useOutlier: false,
      divsionTableSUmmaryData: {},
      tableData: [],
      filterData: [],
      bciInfo: { length: 0, opport: 0 },
      enableSave: false,
      tableHeight: 250,
      openPopUp: false,
      openTrendPopUp: false,
      historicalTrendData: [],
      selectedCustomerData: null,
      selectedCustomerDataDivison: null,
      powerBiSelectedCustomer: "",
      pInfo: { length: 0, opport: 0 },
      scatterData: null,
      scatterSummaryCopy: null,
      minYAxis: 0,
      maxYAxis: 0,
      recommendationAction: [],
      divisionFilter: [],
      tempDivisionFilter: [],
      isGoBackLinkVisible: false,
      setGoBackLinkValue: null,
      rowHighlightIndex: null,
      rowHighlightDivIndex: null,
      handlePaginationAPI: null,
      totalOpportunity: 0,
      totalCustomers: 0,
      orderBy: "opportunity",
      order: "desc",
      pageSize: 10,
      pageNumber: 1,
      setPayloadVariables: null,
      isInputValManipulated: false,
      openOpportunityPopup: false,
      openPopup: false,
      graphHeight: 190,
      graphWidth: 600,
      customer_class_values: [],
      customer_class_all_values: [],
      customer_class: [],
      disabledCheckPicker: [],
      divison: false,
      sliderValues: [0, 0],
      isUnselectedUpdated: false,
      updateExpectedPriceDisable: false,
      rejectExpectedPriceDisable: false,
      filter: { projectFlag: ['NonProject'] },
    };
  }

  exportReportHeaders: any = {
    customer_id: "Customer Id",
    Customer_Class: "Customer Class",
    CustomerDesc: "Customer Description",
    itemId: "Item Id",
    current_price: "Current Weighted Average Price ($)",
    peer_weighted_avg_price: "Current Peer Weighted Average Price ($)",
    new_price: "Latest Executed Price ($)",
    updated_by: "Updated By",
    updated_at: "Updated At (UTC +00:00)",
  };

  handlePaginationAPI = (pageSize: any, PageNumber: any) => {
    this.selectedCustomer = "";
    this.setState({
      pageSize: pageSize,
      PageNumber: PageNumber,
    });
    this.getCustomerList(
      pageSize,
      PageNumber,
      this.state.order,
      this.state.orderBy,
      this.state.sliderValues[0],
      this.state.sliderValues[1],
      this.state.filter
    );
  };

  handleSliderAPI = (data: any) => {
    let sliderData: any = { Description: data[2].Description, peerGroupName: data[2].peerGroupName, bill_customer_id: data[2].bill_customer_id, division: data[2].division, itemid: data[2].itemid, projectFlag: data[2].projectFlag }
    this.selectedCustomer = "";
    this.setState({
      sliderValues: data,
      scatterData: null,
    });
    this.getCustomerList(
      10,
      1,
      this.state.order,
      this.state.orderBy,
      data[0],
      data[1],
      data[2]
    );

    getTotalPageNumber({ ...sliderData, userEmail: this.state.userEmail, minOpp: data[0], maxOpp: data[1], projectFlag: this.state.filter.projectFlag })
      .then((response: any) => {
        if (
          response.status === 200 &&
          response.data.data &&
          response.data.data.length
        ) {
          this.setState({
            totalOpportunity: response?.data?.data[0].opportunity,
            totalCustomers: response?.data?.data[0].count,
          });
        }
      })
      .catch((err) => {
        console.log("error in Save APi --", err);
        this.setState({
          pageLoading: false,
        });
      });

  };

  setGoBackLinkValue = (val: boolean) => {
    this.setState({
      isGoBackLinkVisible: val,
    });
  };

  setPayloadVariables = (
    order: any,
    orderBy: any,
    pageSize: any,
    PageNumber: any
  ) => {
    this.setState({
      order,
      orderBy,
      pageSize,
      PageNumber,
    });
    if (
      orderBy === "opportunity" &&
      this.state.isInputValManipulated === true
    ) {
      this.setState({
        openOpportunityPopup: true,
      });
    } else {
      this.getCustomerList(
        pageSize,
        PageNumber,
        order,
        orderBy,
        this.state.sliderValues[0],
        this.state.sliderValues[1],
        this.state.filter
      );
    }
  };

  componentDidMount() {
    // appInsights.trackPageView({ name: "Pricing" });
    // appInsights.startTrackPage("Pricing");
    const arr: any = window.location.hash.split("?");
    if (arr.length > 1) {
      const queryParams = arr[1].split("&");
      window.sessionStorage.setItem(
        "navigateTo",
        arr[0] + "?" + queryParams[0]
      );
      if (queryParams[1] == "close=true") {
        window.close();
      }
      this.setState({
        powerBiSelectedCustomer: queryParams[0]
          .split("=")[1]
          .replaceAll("%20", " "),
        isGoBackLinkVisible: true,
      });
      this.selectedCustomer = queryParams[0]
        .split("=")[1]
        .replaceAll("%20", " ");
    }
    document.title = "Pricing";
    // this.getPCFilters();
    if (this.props.accessType !== "admin" && !this.selectedCustomer) {
      this.getCustomerList(10, 1, "desc", "opportunity", undefined, undefined, this.state.filter);
      this.getTotalCountOfRecords(-1, 0, this.state.filter);
    }

    this.setState({
      tableHeight: window.innerHeight - 280, // minus 140 to fit into the page size
    });
    // window.addEventListener("resize", (event) => {
    //   this.setState({
    //     tableHeight: window.innerHeight - 280, // minus 140 to fit into the page size
    //   });
    // });
  }

  /* getPCFilters = () => {
    this.setState({
      pageLoading: true,
    });
    getAPI(`getPricingFilters`)
      .then((res: any) => {
        if (res.status == 200 && res?.data && res?.data?.data) {
          let pricingFilterData = [
            {
              id: "pc",
              name: "PCs",
              disabled: false,
              default:
                this.props.accessType == "admin" ? "" : this.props.PCs[0],
              data:
                this.props.accessType == "admin"
                  ? res?.data?.data?.price_pc
                  : res?.data?.data?.price_pc?.filter((v: any) =>
                      this.props.PCs?.includes(v.value)
                    ),
              type: "single",
            },
          ];
          this.setState({
            pricingFilterData: pricingFilterData,
            pageLoading: this.props.accessType === "admin" ? false : true,
          });
        }
      })
      .catch((err) => {
        console.log("error in get APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  }; */

  getTotalCountOfRecords = (maxOpp: Number, minOpp: Number, payload: any = {}) => {
    this.setState({
      pageLoading: true,
    });


    getTotalPageNumber({ ...payload, userEmail: this.state.userEmail, minOpp: this.state.sliderValues[0], maxOpp: this.state.sliderValues[1], projectFlag: this.state.filter.projectFlag })

      .then((response: any) => {
        if (
          response.status === 200 &&
          response.data.data &&
          response.data.data.length
        ) {
          this.setState({
            totalOpportunity: response?.data?.data[0].opportunity,
            totalCustomers: response?.data?.data[0].count,
          });
        }
      })
      .catch((err) => {
        console.log("error in Save APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  getCustomerList = (
    pageSize: any,
    PageNumber: any,
    order: any,
    orderBy: any,
    minOpp: any = undefined,
    maxOpp: any = undefined,
    payload: any = {},
    shouldReset: boolean = true
  ) => {
    this.setState({ scatterData: null });
    this.setState(shouldReset ? {
      pageLoading: true,
      tableData: { ...this.state.tableData, list: [] }
    } : { pageLoading: true });
    let data = {
      pageSize: pageSize,
      pageNumber: PageNumber,
      order: order,
      orderBy: orderBy,
      // minOpp:0,
      // maxOpp:0
      minOpp:
        minOpp === undefined ||
          (this.state.sliderValues[0] === 0 && this.state.sliderValues[1] === 0)
          ? ""
          : minOpp,
      maxOpp:
        maxOpp === undefined ||
          (this.state.sliderValues[0] === 0 && this.state.sliderValues[1] === 0)
          ? ""
          : maxOpp,
    };

    getPricingCustomerList(
      {
        data,
      },
      { ...payload, userEmail: this.state.userEmail, projectFlag: this.state.filter.projectFlag }
    )
      .then((response: any) => {
        this.setState({
          pageLoading: false,
          pageNumber: data.pageNumber,
        });
        if (response.status === 200 && response.data) {
          let sortedData = response.data.data;
          sortedData.list = sortedData?.list.sort((a: any, b: any) =>
            a.total.opportunity > b.total.opportunity ? -1 : 1
          );

          sortedData.list.forEach((item: any) => {
            item.divisionList = Object.values(item.divisionList).sort(
              (a: any, b: any) =>
                a.total.opportunity > b.total.opportunity ? -1 : 1
            );

            item.divisionList.forEach((d: any) => {
              let isAggreed = false;

              d.list = d.list.sort((a: any, b: any) =>
                a.opportunity > b.opportunity ? -1 : 1
              );

              d.list.forEach((element: any) => {
                element.copyAdjustedPrice = element.adjustedPrice;
                if (element?.isAgreed === 0) {
                  isAggreed = true;
                }
              });

              d.allAggreed = isAggreed;
            });
          });

          sortedData.list.forEach((item: any) => {
            let allDivisionAgreed = false;
            item.divisionList.forEach((d: any) => {
              if (d.allAggreed) {
                allDivisionAgreed = true;
              }
            });
            item.allDivisionAgreed = allDivisionAgreed;
          });

          if (
            this.state.sliderValues[0] == 0 &&
            this.state.sliderValues[1] == 0
          ) {
            this.setState({
              sliderValues: [response.data.data.minOpp, response.data.data.maxOpp],
            });
          }
          this.setState({
            tableData: { ...sortedData },
            pInfo: {
              length: sortedData.list.length,
              opport: sortedData.totalOpp,
            },
            pageLoading: false,
          });
        }
      })
      .catch((err: any) => {
        console.log("error in getCustomerList APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  getPricingCustomerClassFilter = (payload: any): Promise<boolean> => {
    return new Promise((resolve) => {
      let customer_class: any = [];
      getPricingCustomerClass(payload).then((response: any) => {
        customer_class.push(response.data.data.CustomerClassFilter);
        this.setState(
          {
            pageLoading: false,
            customer_class: response.data.data.CustomerClassFilter.map(
              (d: string) => {
                return { label: d, value: d };
              }
            ),
            customer_class_values: response.data.data.CustomerClassFilter,
            customer_class_all_values: response.data.data.CustomerClassFilter,
          },
          () => resolve(true)
        );
      });
    });
  };

  getDivsionDetailsByCustomer = (payload: any, itemId: any) => {
    this.setState({
      pageLoading: true,
      itemId: itemId,
    });
    // appInsights.trackEvent({
    //   name: "Customer-Item-Level-Details",
    //   properties: { value: payload },
    // });
    getPricingDivsionDataByCustomer({ ...payload, userEmail: this.state.userEmail })
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });

        let division = payload.division;
        let customerId = payload.customer;
        // itemId
        // let tableData = this.state.tableData;
        let execPriceUpdated;

        if (response.status === 200 && response.data) {
          execPriceUpdated = this.getUpdatedExecutedPrice(
            customerId,
            division,
            itemId
          );
          response.data.data.ItemRecommPrice = execPriceUpdated;
          response.data.data.summaryData.executedPrice = execPriceUpdated;

          let itemsArray: any = Object.values(response.data.data.l4AvgPrice)[0];
          let selectedCustomerDetails = itemsArray?.find(
            (d: any) => d.customer === payload.customer
          );
          selectedCustomerDetails.executedPrice = execPriceUpdated;
          selectedCustomerDetails.name = payload.customerDesc;
          // remove the current customer class customer_class_values
          this.setState({
            disabledCheckPicker: [selectedCustomerDetails?.Customer_Class],
            selectedCustomerDetailsItem: selectedCustomerDetails,
          });

          let minYAxis = Infinity;
          let maxYAxis = -Infinity;
          let itemDesc = "";
          let customer_class_values = this.state.customer_class_values;
          Object.values(response.data.data.l4AvgPrice).forEach((data: any) => {
            data.forEach((d: any) => {
              if (maxYAxis < d.price) {
                maxYAxis = d.price;
              }
              if (minYAxis > d.price) {
                minYAxis = d.price;
              }
              itemDesc = d.itemDesc;
              d.copyAxecutedPrice = d.executedPrice;
            });
          });
          minYAxis = Math.round(minYAxis);
          maxYAxis = Math.round(maxYAxis);

          this.setState({
            customer_class_values: customer_class_values.includes(
              selectedCustomerDetails?.Customer_Class
            )
              ? this.state.customer_class_values
              : [
                ...this.state.customer_class_values,
                selectedCustomerDetails?.Customer_Class,
              ],
            disabledCheckPicker: [selectedCustomerDetails?.Customer_Class],
            minYAxis: minYAxis - (minYAxis % 5),
            maxYAxis: maxYAxis + (5 - (maxYAxis % 5)),
            scatterData: response.data.data,
            scatterSummaryCopy: response.data.data.summaryData,
            itemDesc: itemDesc,
            itemExecPrice: response.data.data.ItemRecommPrice,
            selectedCustomerData: selectedCustomerDetails,
            recommendationAction: [],
            isInputValManipulated: false,
          });
        }
      })
      .catch((err) => {
        console.log("error in getCustomerList APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  getUpdatedExecutedPrice = (
    customerId: number,
    division: string,
    itemId: number
  ) => {
    let tableData = this.state.tableData.list;
    let customer;
    let div;
    let itemList;
    let price;
    for (let i = 0; i < tableData.length; i++) {
      if (tableData[i].id == customerId) {
        customer = tableData[i];
        break;
      }
    }
    for (let i = 0; i < customer.divisionList.length; i++) {
      if (customer.divisionList[i].id == division) {
        div = customer.divisionList[i];
        itemList = customer.divisionList[i].list;
        break;
      }
    }

    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i].itemId == itemId) {
        return itemList[i].adjustedPrice;
      }
    }
  };

  handleModalClose = () => {
    this.setState({
      openOpportunityPopup: false,
    });
  };

  proceedWithHandleYes = () => {
    this.getCustomerList(
      this.state.pageSize,
      this.state.PageNumber,
      this.state.order,
      this.state.orderBy
    );
    this.handleModalClose();
    this.setState({
      isInputValManipulated: false,
    });
  };

  setFilterData = () => {
    const filterTemp = [
      {
        id: "category",
        name: "Category",
        default: this.categoryDefault,
        type: "multi",
        data: this.categoryFilterValue,
      },
    ];
    this.setState({
      filterData: filterTemp,
    });
  };

  sortFnLocal = (field: string) => {
    if (this.fieldMatchColumns[field]) {
      field = this.fieldMatchColumns[field];
      if (field === this.sortObj.field) {
        this.sortObj.isAsc = !this.sortObj.isAsc;
      } else {
        this.sortObj.field = field;
        this.sortObj.isAsc = false;
      }
      this.sortTableData(this.sortObj.field, this.sortObj.isAsc);
    }
  };

  handleFilterSelection = (value: any, id: any) => {
    if (id == "pc") {
      if (value !== null) {
        let pricingFilter = this.state.pricingFilterData;
        pricingFilter[0].default = value;
        this.setState({
          pricingFilterData: pricingFilter,
          selectedPC: value,
          scatterData: null,
          selectedCustomerData: null,
        });
        this.getCustomerList(10, 1, "desc", "opportunity");
        this.getTotalCountOfRecords(-1, 0);
      } else {
        let pricingFilter = this.state.pricingFilterData;
        pricingFilter[0].default = value;
        this.setState({
          tableData: [],
          scatterData: null,
          pricingFilterData: pricingFilter,
          selectedPC: value,
          totalOpportunity: 0,
          totalCustomers: 0,
          customer_class: [],
          customer_class_values: [],
          useOutlier: false,
        });
      }
    }
  };

  formatNumberWithSuffix = (num: number): string => {
    const suffixes = ["", "k", "M", "B"];
    const suffixIndex = Math.floor(Math.log10(Math.abs(num)) / 3);
    const scaledNum = num / Math.pow(10, suffixIndex * 3);
    const formattedNum = scaledNum.toFixed(2);
    return formattedNum + suffixes[suffixIndex];
  };

  handleSliderChange = (newValues: [number, number]) => {
    this.setState({ sliderValues: newValues });
  };

  getAdvancedFilterValues = () => {
    let temp: any = JSON.parse(JSON.stringify(this.tableDataBackup));
    temp = temp.filter((d: any) => {
      if (
        this.categoryDefault.length > 0 &&
        !this.categoryDefault.includes(d.category)
      ) {
        return false;
      }
      return true;
    });
    let t1 = temp.map((d1: any) => {
      d1.itemList.forEach((d2: any) => {
        const t = d2.divisionWise.filter((d: any) => {
          // let returnFlag = true;
          if (
            this.divisionDefault.length > 0 &&
            !this.divisionDefault.includes(d.division)
          ) {
            return false;
          }
          return true;
        });
        d2.divisionWise = t;
      });
      return d1;
    });
    let opportSum = 0;
    t1 = t1.map((d1: any) => {
      d1.itemList = d1.itemList.filter((d2: any) => d2.divisionWise.length > 0);
      return d1;
    });
    t1 = t1.filter((d: any) => d.itemList.length > 0);
    let itemCount = 0;
    t1.forEach((d: any) => {
      d.opport = 0;
      d.vol = 0;
      d.rev = 0;
      d.marg = 0;
      d.itemList.forEach((d1: any) => {
        d1.opport = 0;
        d1.vol = 0;
        d1.rev = 0;
        d1.marg = 0;
        d1.divisionWise.forEach((d2: any) => {
          d.opport += d2.opport;
          d.vol += d2.vol;
          d.rev += d2.rev;
          d.marg += d2.marg;
          d1.opport += d2.opport;
          d1.vol += d2.vol;
          d1.rev += d2.rev;
          d1.marg += d2.marg;
        });
        if (d1.opport > 0) {
          itemCount += 1;
        }
      });
      opportSum += d.opport;
    });
    this.setState({
      tableData: t1,
      bciInfo: {
        length: itemCount,
        opport: opportSum,
      },
    });
    if (this.clickedItem) {
      this.handleTableRowClick(
        { itemId: this.clickedItem, productType: this.selectedProductType },
        t1
      );
    }
    this.setFilterData();
  };

  setTableData = (data: any, event: any = null, isSort: boolean = false) => {
    const obj: any = {};
    let opportSum = 0;
    const catgoryObj: any = {};
    const divisionObj: any = {};
    const weekObj: any = {};
    this.categoryFilterValue = [];
    // this.divisionFilterValue = [];
    this.weekFilterValue = [];
    let max = "";
    data.forEach((d: any) => {
      if (!catgoryObj[d.category]) {
        catgoryObj[d.category] = 1;
        this.categoryFilterValue.push({
          label: d.category,
          value: d.category,
        });
      }
      if (!divisionObj[d.division]) {
        divisionObj[d.division] = 1;
        // this.divisionFilterValue.push({
        //     label: d.division,
        //     value: d.division,
        // });
      }
      if (!weekObj[d.week]) {
        weekObj[d.week] = 1;
        this.weekFilterValue.push({
          label: d.week,
          value: d.week,
        });
      }
      if (!obj[d.week]) {
        obj[d.week] = {
          week: d.week,
          pType: {},
        };
      }
      if (max < d.week) {
        max = d.week;
      }
      if (!obj[d.week].pType[d.productType]) {
        obj[d.week].pType[d.productType] = {
          vol: 0,
          marg: 0,
          rev: 0,
          opport: 0,
          productType: d.productType,
          category: d.category,
          week: d.week,
          autoloaded: 0,
          modified: 0,
          reviewNeeded: 0,
          inTolerance: 0,
          itemList: {},
        };
      }
      if (!obj[d.week].pType[d.productType].itemList[d.itemId]) {
        obj[d.week].pType[d.productType].itemList[d.itemId] = {
          itemId: d.itemId,
          week: d.week,
          itemType: d.itemType,
          itemDesc: d.itemDesc,
          category: d.category,
          productType: d.productType,
          rule: d.rule,
          isUserOverride: d.isUserOverride,
          ruleType: d.rule <= 0 ? "Below" : "Above",
          vol: 0,
          marg: 0,
          rev: 0,
          opport: 0,
          cfpMin: 0,
          cfpMax: 0,
          autoloaded: 0,
          modified: 0,
          reviewNeeded: 0,
          inTolerance: 0,
          // rec: 0,
          recOverride: d.recOverride,
          divisionWise: [],
        };
      }
      this.fiscalWeek = d.week;
      if (!d.isUserOverride) {
        if (d.InToleranceIndicator === 1) {
          if (d.isRecOverride === 0) {
            if (d.cfpMin <= d.followingPrice && d.cfpMax >= d.followingPrice) {
              obj[d.week].pType[d.productType].itemList[d.itemId].inTolerance++;
              // obj[d.week].pType[d.productType].inTolerance++;
            } else {
              obj[d.week].pType[d.productType].itemList[d.itemId].autoloaded++;
              // obj[d.week].pType[d.productType].autoloaded++;
            }
          } else if (
            d.isRecOverride === 1 &&
            d.cfpMin <= d.recOverride &&
            d.cfpMax >= d.recOverride
          ) {
            obj[d.week].pType[d.productType].itemList[d.itemId].modified++;
            // obj[d.week].pType[d.productType].modified++;
          } else {
            obj[d.week].pType[d.productType].itemList[d.itemId].reviewNeeded++;
            // obj[d.week].pType[d.productType].reviewNeeded++;
          }
        }
      } else {
        obj[d.week].pType[d.productType].itemList[d.itemId].modified++;
      }
      // if (d.recOverride !== obj[d.week].pType[d.productType].itemList[d.itemId].recOverride) {
      //     obj[d.week].pType[d.productType].itemList[d.itemId].recOverride = null;
      // }
      obj[d.week].pType[d.productType].itemList[d.itemId].divisionWise.push({
        div: d.division,
        division: d.division,
        week: d.week,
        itemId: d.itemId,
        iType: d.itemType,
        vol: d.volume,
        rev: d.revenue,
        marg: d.margin,
        rule: d.rule,
        InToleranceIndicator: d.InToleranceIndicator,
        ruleType: d.rule <= 0 ? "Below" : "Above",
        opport: d.opportunity,
        minThreshold: d.minThreshold,
        maxThreshold: d.maxThreshold,
        leadingPrice: d.leadingPrice,
        followingPrice: d.followingPrice,
        cfpMin: d.cfpMin,
        fiscalWeek: this.fiscalWeek,
        cfpMax: d.cfpMax,
        isUserOverride: d.isUserOverride,
        // autoloaded: d.recOverride ? false : true,
        // modified: d.recOverride ? true : false,
        // modifyClick: false,
        // rec: d.cfpMax - d.cfpMin,
        recOverride: d.recOverride,
        isRecOverride: d.isRecOverride,
        isModifyChange: false,
        isLocalModifyFlag: true,
        itemBrand: d.itemBrand,
      });
      if (
        d.rule &&
        d.rule !== obj[d.week].pType[d.productType].itemList[d.itemId].rule
      ) {
        obj[d.week].pType[d.productType].itemList[d.itemId].rule = null;
        obj[d.week].pType[d.productType].itemList[d.itemId].ruleType = null;
      }
      // if (d.recOverride) {
      //     obj[d.week].pType[d.productType].itemList[d.itemId].rec += (d.cfpMax - d.cfpMin) * d.volume;
      // } else {
      // obj[d.week].pType[d.productType].itemList[d.itemId].rec += (d.cfpMax - d.cfpMin) * d.volume;
      // }
      obj[d.week].pType[d.productType].itemList[d.itemId].recOverride +=
        d.recOverride * d.volume;

      obj[d.week].pType[d.productType].itemList[d.itemId].cfpMin += d.cfpMin;
      obj[d.week].pType[d.productType].itemList[d.itemId].cfpMax += d.cfpMax;
      obj[d.week].pType[d.productType].itemList[d.itemId].vol += d.volume;
      obj[d.week].pType[d.productType].itemList[d.itemId].rev += d.revenue;
      obj[d.week].pType[d.productType].itemList[d.itemId].marg += d.margin;
      obj[d.week].pType[d.productType].itemList[d.itemId].opport +=
        d.opportunity;
      obj[d.week].pType[d.productType].vol += d.volume;
      obj[d.week].pType[d.productType].rev += d.revenue;
      obj[d.week].pType[d.productType].marg += d.margin;
      obj[d.week].pType[d.productType].opport += d.opportunity;
      opportSum += d.opportunity;
    });
    this.weeksData = obj;
    this.weekDefault = max;
    let tableData = Object.values(obj[this.weekDefault].pType);
    tableData.forEach((d: any) => {
      d.itemList = Object.values(d.itemList);
      let arr1 = d.itemList.filter((d: any) => d.isUserOverride === 1);
      d.modified = arr1.length;
      let arr = d.itemList.filter(
        (d: any) =>
          d.InToleranceIndicator === 1 &&
          d.inTolerance !== 0 &&
          d.isUserOverride !== 1
      );
      d.autoloaded = d.itemList.length - arr.length - arr1.length;
      d.inTolerance = arr.length;
    });
    if (isSort) {
      tableData = this.sortTableData(
        this.sortObj.field,
        this.sortObj.isAsc,
        tableData
      );
    }
    if (event && event.index) {
      // tableData = this.tableRuleChanges(event.parentFlag, event.val, event.index, event.childIndex, Object.values(obj))
      tableData = this.tableRuleChanges(
        event.parentFlag,
        event.val,
        event.index,
        event.childIndex,
        Object.values(obj[this.weekDefault].pType)
      );

      const summary = tableData.filter(
        (d: any) => d.itemId === event.itemId
      )[0];
      this.setState({
        divsionTableSUmmaryData: summary,
      });
    }
    // this.setFilterData();
    this.tableDataBackup = tableData;
    // this.handleFilterSelection(this.weekFilterValue[0].value, 'week');
    // this.handleFilterSelection(["Disposables & Tabletop"], 'category');
    // this.setState({
    //     tableData: tableData,
    //     bciInfo: {
    //         length: Object.values(obj).length,
    //         opport: opportSum,
    //     }
    // });
  };

  handleModify = (pIndex: number, iIndex: number, dIndex: number) => {
    const data = this.state.tableData;
    data[pIndex].itemList[iIndex].divisionWise[dIndex].isUserOverride = 0;
    data[pIndex].itemList[iIndex].divisionWise[dIndex].isModifyChange = true;
    data[pIndex].itemList[iIndex].autoloaded = 0;
    data[pIndex].itemList[iIndex].modified = 0;
    data[pIndex].itemList[iIndex].reviewNeeded = 0;
    data[pIndex].itemList[iIndex].inTolerance = 0;
    data[pIndex].itemList[iIndex].divisionWise.forEach((d: any) => {
      if (d.isUserOverride) {
        data[pIndex].itemList[iIndex].modified++;
      } else {
        if (data[pIndex].itemList[iIndex].divisionWise[dIndex].isModifyChange) {
          data[pIndex].itemList[iIndex].autoloaded++;
        } else {
          if (d.isRecOverride) {
            if (d.cfpMin <= d.recOverride && d.cfpMax >= d.recOverride) {
              data[pIndex].itemList[iIndex].modified++;
            } else {
              data[pIndex].itemList[iIndex].reviewNeeded++;
            }
          } else {
            if (d.cfpMin <= d.followingPrice && d.cfpMax >= d.followingPrice) {
              data[pIndex].itemList[iIndex].inTolerance++;
            } else {
              data[pIndex].itemList[iIndex].autoloaded++;
            }
          }
        }
      }
    });
    this.setState({
      tableData: data,
    });
  };

  handleRecChanges = (
    event: any,
    type: string,
    pIndex: number,
    iIndex: number,
    dIndex: number
  ) => {
    const data = this.state.tableData;
    let totalOpport;
    if (type === "item") {
      data[pIndex].itemList[iIndex].modified =
        data[pIndex].itemList[iIndex].divisionWise.length;
      data[pIndex].itemList[iIndex].autoloaded = 0;
      data[pIndex].itemList[iIndex].divisionWise.forEach((d: any) => {
        d.autoloaded = false;
        d.modified = true;
        d.recOverride = event.target.value;
        this.setSavedChangesRec(d, false, pIndex, iIndex, dIndex);
      });
      let arr = data[pIndex].itemList.filter((d: any) => d.autoloaded === 0);
      data[pIndex].autoloaded = data[pIndex].itemList.length - arr.length;
      data[pIndex].modified = arr.length;
    } else {
      totalOpport =
        this.state.bciInfo.opport - data[pIndex].itemList[iIndex].opport;
      // data[pIndex].itemList[iIndex].divisionWise[dIndex].isRecOverride = 1;
      // let arr1 = data[pIndex].itemList[iIndex].divisionWise.filter((d: any) => d.isRecOverride === 1);
      // data[pIndex].itemList[iIndex].modified = arr1.length;
      data[pIndex].itemList[iIndex].divisionWise[dIndex].recOverride = Number(
        event.target.value
      );
      data[pIndex].itemList[iIndex].divisionWise[dIndex].isLocalModifyFlag =
        true;
      // data[pIndex].itemList[iIndex].autoloaded = data[pIndex].itemList[iIndex].divisionWise.length - arr1.length;
      // let arr = data[pIndex].itemList.filter((d: any) => d.modified !== 0);
      // data[pIndex].autoloaded = data[pIndex].itemList.length - arr.length;
      // data[pIndex].modified = arr.length;
      let old = data[pIndex].itemList[iIndex].divisionWise[dIndex].opport;
      data[pIndex].itemList[iIndex].divisionWise[dIndex].opport =
        (Number(event.target.value) -
          data[pIndex].itemList[iIndex].divisionWise[dIndex].followingPrice) *
        data[pIndex].itemList[iIndex].divisionWise[dIndex].vol;
      if (data[pIndex].itemList[iIndex].divisionWise[dIndex].opport < 0) {
        data[pIndex].itemList[iIndex].divisionWise[dIndex].negOpp =
          data[pIndex].itemList[iIndex].divisionWise[dIndex].opport;
        data[pIndex].itemList[iIndex].negOpp =
          data[pIndex].itemList[iIndex].opport +
          (data[pIndex].itemList[iIndex].divisionWise[dIndex].negOpp + old);
        data[pIndex].itemList[iIndex].divisionWise[dIndex].opport = 0;
      } else {
        data[pIndex].itemList[iIndex].divisionWise[dIndex].negOpp = 0;
        data[pIndex].itemList[iIndex].negOpp = 0;
      }
      data[pIndex].itemList[iIndex].opport +=
        data[pIndex].itemList[iIndex].divisionWise[dIndex].opport - old;
      data[pIndex].itemList[iIndex].divisionWise[dIndex].isModifyChange = true;
      // data[pIndex].itemList[iIndex].rec = 0;
      data[pIndex].itemList[iIndex].recOverride = 0;
      data[pIndex].itemList[iIndex].divisionWise.forEach((d: any) => {
        if (d.recOverride) {
          // data[pIndex].itemList[iIndex].rec += d.recOverride * d.vol;
          data[pIndex].itemList[iIndex].recOverride += d.recOverride * d.vol;
        } else {
          // data[pIndex].itemList[iIndex].rec += (d.cfpMax - d.cfpMin) * d.vol;
          data[pIndex].itemList[iIndex].recOverride +=
            (d.cfpMax - d.cfpMin) * d.vol;
        }
      });
      data[pIndex].itemList[iIndex].recOverride =
        Math.round(
          (data[pIndex].itemList[iIndex].recOverride /
            data[pIndex].itemList[iIndex].vol) *
          10
        ) / 10;
      totalOpport += data[pIndex].itemList[iIndex].opport;

      this.setSavedChangesRec(
        data[pIndex].itemList[iIndex].divisionWise[dIndex],
        false,
        pIndex,
        iIndex,
        dIndex
      );
    }
    if (this.clickedItem) {
      this.handleTableRowClick(
        { itemId: this.clickedItem, productType: this.selectedProductType },
        data
      ); // 0 is just dummy value
    }
    this.setState({
      tableData: data,
      bciInfo: {
        length: this.state.bciInfo.length,
        opport: totalOpport,
      },
    });
  };

  handleTableRowClick = (event: any, isOutlierChangeEvent: boolean = false) => {
    if (this.state.scatterData !== null) {
      let itemsArray: any = Object.values(this.state.scatterData.l4AvgPrice)[0];
      let selectedCustomerDetails = itemsArray?.find(
        (d: any) => d.customer === this.clickedTableRow.bill_customer_id
      );
      if (this.state.isInputValManipulated) {
        this.handleExecutionPriceChange(
          selectedCustomerDetails.executedPrice,
          selectedCustomerDetails.price
        );
      }
    }
    this.clickedTableRow = event;
    let payload: any;

    if (
      event.bill_customer_id !== undefined &&
      event.itemId !== undefined &&
      event.division !== undefined
    ) {
      payload = {
        itemId: event.itemId,
        // price_pc: this.state.selectedPC,
        division: event.division,
        customer: event.bill_customer_id,
        customer_class: event.Customer_Class,
        item_desc: event.Description,
        // erpPriceLineId: event.ErpPriceLineId,
        customerDesc: event.customerDesc,
        opportunity: event.opportunity,
        quantity: event.quantity,
        revenue: event.revenue,
        peerGroupName: event.peerGroupName,
        project_flag: event.project_flag
      };
      if (this.state.useOutlier) {
        payload["useOutlier"] = true;
      }
      // if (this.state.homeFlag) {
      //   payload["home"] = true;
      // }
      if (this.state.customer_class_values.length) {
        let cust_class = this.state.customer_class_values;
        payload["customer_class"] = cust_class;
      }
    }
    if (this.state.itemId == event.itemId && isOutlierChangeEvent === false) {
      this.setState({
        selectedCustomerData: null,
        scatterData: null,
        itemId: "",
        minYAxis: 0,
        maxYAxis: 0,
        recommendationAction: [],
      });
    } else {
      /*  this.setState({
         selectedCustomerData: event
       }) */
      this.getDivsionDetailsByCustomer(payload, event.itemId);
    }
  };

  tableRuleChanges = (
    parentFlag: boolean,
    val: any,
    index: number,
    childIndex: number,
    tableData: any
  ) => {
    if (parentFlag) {
      tableData[index].divisionWise.forEach((d: any) => {
        d.rule = val;
      });
    } else {
      tableData[index].divisionWise[childIndex].rule = val;
      if (
        tableData[index].rule &&
        tableData[index].divisionWise[childIndex].rule !== tableData[index].rule
      ) {
        tableData[index].rule = null;
      } else {
        let notMatchflag = false;
        tableData[index].divisionWise.forEach((d: any) => {
          if (val !== d.rule) {
            notMatchflag = true;
          }
        });
        if (!notMatchflag) {
          tableData[index].rule = val;
        }
      }
    }
    return tableData;
  };

  sortTableData = (field: any, isAsc: boolean = true, data: any = []) => {
    const tableData = data.length ? data : this.state.tableData;
    if (isAsc) {
      tableData.sort(function (a: any, b: any) {
        if (typeof a[field] !== "string") {
          return a[field] - b[field];
        } else {
          return a[field].localeCompare(b[field]);
        }
      });
      tableData.forEach((d: any) => {
        d.itemList.sort(function (a: any, b: any) {
          if (typeof a[field] !== "string") {
            return a[field] - b[field];
          } else {
            return a[field].localeCompare(b[field]);
          }
        });
      });
      tableData.forEach((d: any) => {
        d.itemList.forEach((d1: any) => {
          d1.divisionWise.sort(function (a: any, b: any) {
            if (typeof a[field] !== "string") {
              return a[field] - b[field];
            } else {
              return a[field].localeCompare(b[field]);
            }
          });
        });
      });
    } else {
      tableData.sort(function (a: any, b: any) {
        if (typeof a[field] !== "string") {
          return b[field] - a[field];
        } else {
          return b[field].localeCompare(a[field]);
        }
      });
      tableData.forEach((d: any) => {
        d.itemList.sort(function (a: any, b: any) {
          if (typeof a[field] !== "string") {
            return b[field] - a[field];
          } else {
            return b[field].localeCompare(a[field]);
          }
        });
      });
      tableData.forEach((d: any) => {
        d.itemList.forEach((d1: any) => {
          d1.divisionWise.sort(function (a: any, b: any) {
            if (typeof a[field] !== "string") {
              return b[field] - a[field];
            } else {
              return b[field].localeCompare(a[field]);
            }
          });
        });
      });
    }
    if (data.length) {
      return tableData;
    } else {
      this.setState({
        tableData: tableData,
      });
    }
  };

  handleRuleChange = (
    type: string,
    event: any,
    productTypeIndex: number,
    index: number,
    data: any,
    parentFlag: boolean,
    childIndex: number
  ) => {
    if (event.target.value && data.rule != null) {
      let val;
      if (type === "ruleType") {
        if (event.target.value === "Below") {
          val = data.rule;
          if (!data.rule.toString().includes("-")) {
            val = "-" + data.rule;
          }
        } else {
          val = Math.abs(data.rule);
        }
      } else {
        if (data.ruleType === "Below") {
          val = "-" + event.target.value;
        } else {
          val = event.target.value;
        }
      }
      val = Number(val);
      const tableData = this.ruleCalculation(
        event.target.value,
        this.state.tableData,
        data.itemId,
        data.division ? data.division : null,
        val,
        index,
        childIndex,
        productTypeIndex,
        type,
        event.target.value
      );

      if (this.clickedItem) {
        this.handleTableRowClick(
          { itemId: this.clickedItem, productType: this.selectedProductType },
          tableData
        );
      }
    }
  };

  setSavedChanges = (d: any, parentFlag: boolean = false) => {
    this.setState({
      enableSave: true,
    });
    const objCheck = `${d.itemId}_${d.division}`;
    if (!this.changesObj[objCheck]) {
      this.changesObj[objCheck] = {
        cfpMin: d.cfpMin,
        cfpMax: d.cfpMax,
        opportunity: d.opport,
        itemId: d.itemId,
        division: d.division,
        rule: d.rule,
        ruleType: "Below",
      };
    }
    if (parentFlag) {
      this.changesObj[objCheck].division = null;
    }

    this.changesObj[objCheck].rule = Math.abs(d.rule);
    this.changesObj[objCheck].cfpMin = d.cfpMin;
    this.changesObj[objCheck].cfpMax = d.cfpMax;
    this.changesObj[objCheck].opportunity = d.opport;
    this.changesObj[objCheck].ruleType = d.ruleType;
  };

  setSavedChangesRec = (
    d: any,
    parentFlag: boolean = false,
    pIndex: number,
    iIndex: number,
    dIndex: number
  ) => {
    const objCheck = `${d.itemId}_${d.division}`;
    if (!this.changesObjRec[objCheck]) {
      this.changesObjRec[objCheck] = {
        itemId: d.itemId,
        division: d.division,
        isRecOverride: 1,
        recOverride: d.recOverride ? d.recOverride : d.rec,
        FiscalWeek: d.week,
        opportunity: d.opport,
        pIndex,
        iIndex,
        dIndex,
        rule: Math.abs(d.rule),
        ruleType: d.ruleType,
        cfpMin: d.cfpMin,
        cfpMax: d.cfpMax,
      };
    }
    this.changesObjRec[objCheck].recOverride = d.recOverride
      ? d.recOverride
      : d.rec;
    this.changesObjRec[objCheck].opportunity = d.opport;
  };

  ruleCalculation = (
    target: any,
    data: any,
    itemId: string,
    div: string,
    ruleValue: any,
    index: number,
    childIndex: number,
    pIndex: number,
    type: string,
    value: string
  ) => {
    // data.forEach((d: any) => {
    //     if (d.itemId === itemId) {
    data[pIndex].itemList[index].rule = ruleValue;
    if (ruleValue < 0) {
      data[pIndex].itemList[index].ruleType = "Below";
    } else if (ruleValue > 0) {
      data[pIndex].itemList[index].ruleType = "Above";
    }
    if (target === "Above" && ruleValue == 0) {
      data[pIndex].itemList[index].ruleType = "Above";
    }
    if (target === "Below" && ruleValue == 0) {
      data[pIndex].itemList[index].ruleType = "Below";
    }
    let totalOpport =
      this.state.bciInfo.opport - data[pIndex].itemList[index].opport;
    data[pIndex].itemList[index].opport = 0;
    data[pIndex].itemList[index].divisionWise.forEach((d: any, i: number) => {
      if (
        (childIndex !== undefined && childIndex === i) ||
        childIndex === undefined
      ) {
        d.rule = ruleValue;
        if (ruleValue < 0) {
          d.ruleType = "Below";
        } else if (ruleValue > 0) {
          d.ruleType = "Above";
        }
        if (target === "Above" && ruleValue == 0) {
          d.ruleType = "Above";
        }
        if (target === "Below" && ruleValue == 0) {
          d.ruleType = "Below";
        }
        if (ruleValue <= 0) {
          d.cfpMin =
            (1 - (Math.abs(ruleValue) - d.minThreshold)) * d.leadingPrice;
          if (d.cfpMin < 0) {
            d.cfpMin = 0;
          }
          d.cfpMax =
            (1 - (Math.abs(ruleValue) - d.maxThreshold)) * d.leadingPrice;
          if (d.cfpMax < 0) {
            d.cfpMax = 0;
          }
        } else {
          d.cfpMin =
            (1 + (Math.abs(ruleValue) + d.minThreshold)) * d.leadingPrice;
          if (d.cfpMin < 0) {
            d.cfpMin = 0;
          }
          d.cfpMax =
            (1 + (Math.abs(ruleValue) + d.maxThreshold)) * d.leadingPrice;
          if (d.cfpMax < 0) {
            d.cfpMax = 0;
          }
        }
      }
      if (d.rule && d.rule !== data[pIndex].itemList[index].rule) {
        data[pIndex].itemList[index].rule = null;
      }
      if (d.ruleType && d.ruleType !== data[pIndex].itemList[index].ruleType) {
        data[pIndex].itemList[index].ruleType = null;
      }
      // if (d.isRecOverride === 0) {
      if (d.cfpMin <= d.followingPrice && d.cfpMax >= d.followingPrice) {
        // d.negOpp = d.opport;
        // if (!data[pIndex].itemList[index].negOpp) {
        //     data[pIndex].itemList[index].negOpp = 0;
        // }
        // data[pIndex].itemList[index].negOpp += d.opport;
        d.opport = 0;
      } else {
        d.opport = ((d.cfpMin + d.cfpMax) / 2 - d.followingPrice) * d.vol;
        if (d.opport < 0) {
          d.negOpp = d.opport;
          // if (!data[pIndex].itemList[index].negOpp) {
          //     data[pIndex].itemList[index].negOpp = 0;
          // }
          // data[pIndex].itemList[index].negOpp += d.opport;
          d.opport = 0;
        } else {
          d.negOpp = 0;
          // data[pIndex].itemList[index].negOpp = 0;
        }
      }
      d.recOverride = Math.round(((d.cfpMax + d.cfpMin) / 2) * 100) / 100;
      data[pIndex].itemList[index].opport += d.opport;
      this.setSavedChanges(d);
    });
    totalOpport += data[pIndex].itemList[index].opport;
    // if (type === "ruleType") {
    //     if (childIndex !== undefined) {
    //         data[pIndex].itemList[index].divisionWise[childIndex].ruleType = value;
    //     } else {
    //         data[pIndex].itemList[index].ruleType = value;
    //     }
    // }
    this.setState({
      bciInfo: {
        length: this.state.bciInfo.length,
        opport: totalOpport,
      },
    });
    // }
    // });
    return data;
  };

  handleAcceptFromCustomerSelect = (
    itemData: any = "",
    itemId: any = "",
    isRecOverrideFlag: boolean = false,
    deSelectlag: boolean = false
  ) => {
    let recActionData: any = this.state.recommendationAction;
    let timestamp = Date.now();
    if (deSelectlag) {
      delete recActionData.itemData;
    } else {
      recActionData["itemData"] = itemData;
      recActionData["itemData"].itemId = itemId;
      recActionData["itemData"].isRecOverrideFlag = isRecOverrideFlag;
      // recActionData["itemData"].PC = this.state.selectedPC;
      recActionData["itemData"].divisionId = this.clickedTableRow.division;
      recActionData["itemData"].recOverride = Number(itemData.executedPrice);
      recActionData["itemData"].oldExecutedPrice =
        this.state.selectedCustomerData.recOverride;
      (recActionData["itemData"].current_price = itemData.price),
        (recActionData["itemData"].peer_weighted_avg_price =
          this.state.scatterData.summaryData.l4RecommPrice),
        (recActionData["itemData"].updatedAt = timestamp);
      recActionData["itemData"].updatedBy = this.props.userId;
    }
    this.setState({
      recommendationAction: recActionData,
    });
  };

  handleRecAccept = (payload: any) => {
    this.setState({
      pageLoading: true,
    });
    let putObj = [];
    putObj.push(payload);
    updatePricingDataRec({ data: putObj })
      .then((response: any) => {
        if (response.status === 200) {
          this.getCustomerList(
            10,
            1,
            "desc",
            "opportunity",
            // this.state.selectedPC,
            // this.state.homeFlag
          );
          this.getTotalCountOfRecords(-1, 0);
        }
      })
      .catch((err: any) => {
        console.log("error in handleSubmit APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  handleSubmit = () => {
    this.setState({
      pageLoading: true,
    });
    UpdateBrandCost({ data: Object.values(this.changesObj) })
      .then((response: any) => {
        this.setState({
          pageLoading: false,
          enableSave: false,
        });
        if (response.status === 200 || response.status === 204) {
          this.changesObj = {};
          // Alert.success("Data updated successfully");
        } else {
          // Alert.error("Something went wrong. Please try again after sometime");
        }
      })
      .catch((err: any) => {
        console.log("error in handleSubmit APi --", err);
        // Alert.error("Something went wrong. Please try again after sometime");
        this.setState({
          pageLoading: false,
        });
      });
  };

  saveReason = () => {
    this.setState({
      pageLoading: true,
    });
    UpdateSaveReason({ data: this.nrData })
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });
        if (response.status === 200 || response.status === 204) {
          this.handleClose();
          this.nrData = [];
          // Alert.success("Data updated successfully");
        } else {
          // Alert.error("Something went wrong. Please try again after sometime");
        }
      })
      .catch((err: any) => {
        console.log("error in handleSubmit APi --", err);
        // Alert.error("Something went wrong. Please try again after sometime");
        this.setState({
          pageLoading: false,
        });
      });
  };

  handleBCISubmit = () => {
    this.setState({
      pageLoading: true,
    });
    submitBCI({ data: [{ fiscalWeek: this.fiscalWeek }] })
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });
        if (response.status === 200 || response.status === 204) {
          // Alert.success("Data updated successfully");
        } else {
          // Alert.error("Something went wrong. Please try again after sometime");
        }
        setTimeout(() => {
          window.location.reload();
        }, 500);
      })
      .catch((err: any) => {
        console.log("error in handleBCISubmit APi --", err);
        // Alert.error("Something went wrong. Please try again after sometime");
        this.setState({
          pageLoading: false,
        });
      });
  };

  handleReset = () => {
    this.changesObj = {};
    this.categoryDefault = ["Dairy and Processed Potatoes"];
    this.divisionDefault = [];
    this.clickedItem = null;
    this.clickedItemDesc = null;
    this.selectedProductType = null;
    this.sortObj = {
      field: "opport",
      isAsc: false,
    };
    this.setState({
      divisionData: [],
      divsionTableSUmmaryData: [],
      enableSave: false,
    });
    // this.getBrandData();
  };

  handleClose = () => {
    this.setState({
      openPopUp: false,
      openTrendPopUp: false,
    });
  };

  handleOpen = () => {
    this.setState({
      openPopUp: true,
    });
  };

  thousands = (value: any) =>
    `${value}`.replace(/(?=(?!(\b))(\d{3})+$)/g, "$1,");

  tempDivChange(division: any, scatterData: any, customerData: any) {
    this.setState({
      pageLoading: true,
      openTrendPopUp: true,
    });

    if (division) {
      this.setState({
        tempDivisionFilter: [division],
      });
    } else {
      this.setState({
        tempDivisionFilter: [],
      });
    }

    getPricingMonthlyTrend(
      customerData.customerId,
      Object.keys(scatterData.l4RecommPrice)[0],
      division
    )
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });

        if (
          response.status === 200 &&
          response.data &&
          response.data.data.length
        ) {
          this.setState({
            historicalTrendData: response.data.data,
          });
        }
      })
      .catch((err: any) => {
        console.log("error in GET APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  }

  handleExecPriceInTable = (
    executedPrice: any,
    currentPrice: number,
    selectedRow: any,
    highlightedItemId: number
  ) => {
    this.setState(
      {
        isUnselectedUpdated: !(highlightedItemId == selectedRow.itemId),
      },
      () => {
        this.clickedTableRow = selectedRow;
        console.log(highlightedItemId, selectedRow.itemId, "changes");
        if (this.state.divison) {
          this.handleExecutionPriceChangeTop5(
            executedPrice,
            currentPrice,
            selectedRow.itemId
          );
        } else {
          this.handleExecutionPriceChange(executedPrice, currentPrice);
        }
      }
    );
  };

  handleExecutionPriceChange = (executedPrice: any, currentPrice: number) => {
    console.log(executedPrice, currentPrice, 321);
    let execPrice =
      executedPrice.toString().split(".").length > 2
        ? parseFloat(executedPrice)
        : executedPrice;
    console.log(execPrice, 1);
    let scatterDataCopy = null;
    let payload = this.updateOpportunity(execPrice, Number(currentPrice));
    if (this.state.scatterData != null) {
      scatterDataCopy = JSON.parse(JSON.stringify(this.state.scatterData));
      scatterDataCopy.ItemRecommPrice = execPrice;
      scatterDataCopy.summaryData.executedPrice = execPrice;
      scatterDataCopy.summaryData.opportunity = payload.totalOpp.opportunity;
    }
    let updatedData = payload.updatedTableData;

    this.setState(
      {
        scatterData: this.state.isUnselectedUpdated
          ? this.state.scatterData
          : scatterDataCopy,
        // isInputValManipulated: false,
        recommendationAction: [],
        tableData: updatedData,
      },
      () => {
        this.setState({
          isUnselectedUpdated: false,
        });
      }
    );
  };

  handleExecutionPriceChangeTop5 = (
    executedPrice: any,
    currentPrice: number,
    itemId: string
  ) => {
    this.clickedTableRow.itemId = itemId;
    let execPrice =
      executedPrice.toString().split(".").length > 2
        ? parseFloat(executedPrice)
        : executedPrice;
    let scatterDataCopy = null;
    let payload = this.updateOpportunity(execPrice, Number(currentPrice));
    if (this.state.scatterData != null) {
      scatterDataCopy = JSON.parse(JSON.stringify(this.state.scatterData));
      console.log(scatterDataCopy, 123);
      scatterDataCopy?.l4AvgPrice[itemId].forEach((d: any, i: number) => {
        if (d?.customer == this.clickedTableRow.bill_customer_id) {
          d.executedPrice = execPrice;
          d.opportunity = payload.totalOpp.opportunity;
        }
      });
    }
    let updatedData = payload.updatedTableData;

    this.setState(
      {
        scatterData: scatterDataCopy,
        // isInputValManipulated: false,
        recommendationAction: [],
        tableData: updatedData,
      },
      () => {
        this.setState({
          isUnselectedUpdated: false,
        });
      }
    );
  };

  updateOpportunity = (execPrice: any, currentPrice: number) => {
    let custId = this.clickedTableRow.customerId
      ? this.clickedTableRow.customerId
      : this.clickedTableRow.bill_customer_id;

    // let custId = this.clickedTableRow.customerId;
    let index = this.state.tableData?.list?.findIndex(
      (item: any) => item.id == custId
    );
    let prevOpportunity = 0;
    let newOpportunity = 0;
    let tableRowCustLevel = this.state.tableData.list?.find(
      (divlist: any) => divlist.id === this.clickedTableRow.bill_customer_id
    );
    let itemData = tableRowCustLevel.divisionList?.find(
      (div: any) => div.id === this.clickedTableRow.division
    );
    let totalItemOpportunity: any;
    tableRowCustLevel.divisionList.forEach((div: any) => {
      if (div.id === this.clickedTableRow.division) {
        div.list.forEach((element: any) => {
          if (element.itemId === this.clickedTableRow.itemId) {
            prevOpportunity = element.opportunity;
            element.opportunity = element.quantity * (execPrice - currentPrice);
            newOpportunity = element.quantity * (execPrice - currentPrice);
            totalItemOpportunity = element;
            element.adjustedPrice = execPrice;
          }
        });
        div.total.opportunity =
          itemData.total.opportunity + (newOpportunity - prevOpportunity);
      }
    });

    tableRowCustLevel.total.opportunity =
      tableRowCustLevel.total.opportunity + (newOpportunity - prevOpportunity);

    let dupTableData = JSON.parse(JSON.stringify(this.state.tableData));
    dupTableData.list.splice(index, 1, tableRowCustLevel);
    dupTableData.totalOpp =
      dupTableData.totalOpp + (newOpportunity - prevOpportunity);
    return { totalOpp: totalItemOpportunity, updatedTableData: dupTableData };
  };

  handleExecPriceChangeSubmit = () => {
    this.setState({
      pageLoading: true,
    });

    savePricingExecutedPrice({
      data: [this.state.recommendationAction.itemData],
    })
      .then((response: any) => {
        if (response.status === 200 && response.data) {
          // Alert.success("Data submitted successfully");
          // Set state accordingly
          this.setState({
            pageLoading: false,
          });
        }
      })
      .catch((err: any) => {
        console.log("error in saving execution price data --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  handleToggle = (flag: boolean) => {
    this.setState({ openPopup: flag });
  };

  handleCustomerPicker = (value: any) => {
    // push current customer class to value
    if (this.debounceTimeoutId) {
      clearTimeout(this.debounceTimeoutId);
    }
    this.setState(
      {
        customer_class_values: value,
      },
      () => {
        this.debounceTimeoutId = setTimeout(() => {
          this.handleTableRowClick(this.clickedTableRow, true);
        }, 2000);
      }
    );
  };

  updateOutlierChange = () => {
    this.setState(
      {
        useOutlier: !this.state.useOutlier,
      },
      () => this.handleTableRowClick(this.clickedTableRow, true)
    );
  };

  handleCheckAll = (value: any, checked: any) => {
    this.setState(
      {
        customer_class_values: checked
          ? this.state.customer_class_all_values
          : [this.state.selectedCustomerDetailsItem?.Customer_Class],
      },
      () => this.handleTableRowClick(this.clickedTableRow, true)
    );
  };

  /*   updateNonHomeChange = () => {
      this.setState(
        {
          homeFlag: !this.state.homeFlag,
        },
        async () => {
          let payload = {
            itemId: this.clickedTableRow.itemId,
            price_pc: this.state.selectedPC,
            division: this.clickedTableRow.division,
            customer: this.clickedTableRow.bill_customer_id,
            home: this.state.homeFlag,
          };
          await this.getPricingCustomerClassFilter(payload);
          this.handleTableRowClick(this.clickedTableRow, true);
        }
      );
    };
   */
  handleExportPricingReport = () => {
    this.setState({
      pageLoading: true,
    });
    getAPI("getPriceHistoryForPricing")
      .then((response: any) => {
        if (response?.data?.data?.length) {
          const d = new Date();
          this.exportCSVFile(
            this.exportReportHeaders,
            response.data.data,
            `Price Changes history_${d.getFullYear() +
            "-" +
            (d.getMonth() + 1) +
            "-" +
            d.getDate() +
            ":" +
            d.getHours() +
            ":" +
            d.getMinutes() +
            ":" +
            d.getSeconds()
            }`
          );
        } else {
          // Alert.info("No data found!");
        }
        this.setState({
          pageLoading: false,
        });
      })
      .catch((err) => {
        console.log("error in Save APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  exportCSVFile = (header: any, items: any, fileTitle: string) => {
    if (header) {
      items.unshift(header);
    }
    // Convert Object to JSON
    const jsonObject = JSON.stringify(items);

    const csv = this.convertToCSV(header, jsonObject);

    const exportedFilenmae = fileTitle + ".csv" || "export.csv";

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const navigatorLocal: any = navigator;
    if (navigatorLocal.msSaveBlob) {
      // IE 10+
      navigatorLocal.msSaveBlob(blob, exportedFilenmae);
    } else {
      const link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilenmae);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  wrapperHandleTableRowClick = (
    event: any,
    isOutlierChangeEvent: boolean = false,
    division: boolean = false
  ) => {
    // let payload = {
    //   itemId: event.itemId,
    //   price_pc: this.state.selectedPC,
    //   division: event.division,
    //   customer: event.bill_customer_id,
    //   home: this.state.homeFlag,
    // };
    // this.setState(
    //   {
    //     customer_class: [],
    //     customer_class_values: [],
    //     homeFlag: false,
    //     useOutlier: false,
    //   },
    //   () =>{
    //     this.getPricingCustomerClassFilter(payload)
    //     this.handleTableRowClick(
    //       event,
    //       isOutlierChangeEvent
    //     )
    //   }
    // );
    console.log(event, 321);

    if (division) {
      // this.setState(
      //   {
      //     customer_class: [],
      //     customer_class_values: [],
      //     homeFlag: false,
      //     useOutlier: false,
      //     divison: true,
      //   },
      //   () => {
      //     this.handleTableDivClick(event);
      //   }
      // );
    } else {
      this.setState(
        {
          customer_class: [],
          customer_class_values: [],
          homeFlag: false,
          useOutlier: false,
          divison: false,
        },
        () => {
          this.handleTableRowClick(event);
        }
      );
    }

    /* async () => {
        let payload = {
          itemId: event.itemId,
          division: event.division,
          customer: event.bill_customer_id,
        };
        await this.getPricingCustomerClassFilter(payload); 
      }*/
  };

  handleTableDivClick = (event: any) => {
    if (event?.id && event?.customerId) {
      let payload = {
        division: event?.id,
        customer: event?.customerId,
      };
      let obj = {
        bill_customer_id: event?.customerId,
        division: event?.id,
      };
      this.clickedTableRow = obj;
      this.setState({
        pageLoading: true,
      });
      // appInsights.trackEvent({ name: "Customer-division-Level-Details", properties: { value: payload } });
      getPricingForItemsListTemp(payload, this.state.filter).then(
        (response: any) => {
          this.setState({
            pageLoading: false,
          });
          if (response.status === 200 && response.data) {
            // let itemsArray: any = Object.values(response.data.data.l4AvgPrice)[0];
            // let selectedCustomerDetails = itemsArray.find(
            //   (d: any) => d.customer === payload.customer
            // );

            let selectedCustomerDetails: any = {};
            selectedCustomerDetails.name = event.name;
            selectedCustomerDetails.customer = event?.customerId;
            selectedCustomerDetails.division = event?.id;
            // this.setState({
            //   disabledCheckPicker: [selectedCustomerDetails.Customer_Class],
            //   selectedCustomerDetailsItem: selectedCustomerDetails
            // });

            let minYAxis = Infinity;
            let maxYAxis = -Infinity;
            let itemDesc = "";
            let customer_class_values = this.state.customer_class_values;
            Object.values(response.data.data.l4AvgPrice).forEach(
              (data: any) => {
                data.forEach((d: any) => {
                  d.copyAxecutedPrice = d.executedPrice;
                  if (maxYAxis < d.price) {
                    maxYAxis = d.price + 40;
                  }
                  if (minYAxis > d.price) {
                    minYAxis = d.price;
                  }
                  itemDesc = d.itemDesc;
                });
              }
            );
            minYAxis = Math.round(minYAxis);
            maxYAxis = Math.round(maxYAxis);
            console.log(minYAxis, maxYAxis);
            this.setState({
              // customer_class_values: customer_class_values.includes(
              //   selectedCustomerDetails.Customer_Class
              // )
              //   ? this.state.customer_class_values
              //   : [
              //     ...this.state.customer_class_values,
              //     selectedCustomerDetails.Customer_Class,
              //   ],
              // disabledCheckPicker: [selectedCustomerDetails.Customer_Class],
              minYAxis: 0,
              maxYAxis: maxYAxis + (5 - (maxYAxis % 5)),
              scatterData: response.data.data,
              scatterSummaryCopy: response.data.data.summaryData,
              itemDesc: itemDesc,
              // itemExecPrice: response.data.data.ItemRecommPrice,
              selectedCustomerDataDivison: selectedCustomerDetails,
              recommendationAction: [],
              isInputValManipulated: false,
            });
          }
        }
      );
    }
  };

  convertToCSV = (header: any, objArray: any) => {
    const array =
      typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    let str = "";
    array.forEach((d: any, i: number) => {
      let line = "";
      Object.keys(header).forEach((key) => {
        if (line !== "") {
          line += ",";
        }
        if (array[i][key]) {
          line += array[i][key];
        } else {
          line += "-";
        }
      });
      str += line + "\r\n";
      i++;
    });

    return str;
  };

  prepareUpdateData = (
    data: any,
    isSingle: number = 0,
    customerData: any = null
  ) => {
    console.log(data, 'prepareaccept')
    if (isSingle == 0) {
      let finalData = [data];
      if (finalData?.length !== 0) {
        finalData.forEach((element: any, index: number) => {
          element.isRecOverrideFlag =
            element?.executedPrice !== element?.peerPrice ? 1 : 0;
        });

        return finalData;
      }
    } else if (isSingle == 1) {
      let obj = {},
        finalData: any = [];

      data?.data.forEach((element: any, index: number) => {
        obj = {
          itemId: element?.itemId,
          customerId: element?.bill_customer_id,
          division: data?.division,
          executedPrice: element?.adjustedPrice,
          isRecOverrideFlag:
            element?.Avg_peer_Price !== element?.adjustedPrice ? 1 : 0,
          opportunity: element?.opportunity,
          project_flag: element?.project_flag,
          peerGroupName: element?.peerGroupName
        };
        finalData.push(obj);
      });

      return finalData;
    } else if (isSingle == 2) {
      let obj = {},
        finalData: any = [];

      data?.data?.divisionList.forEach((d: any) => {
        let division = d?.id;
        d?.list.forEach((element: any) => {
          obj = {
            itemId: element?.itemId,
            customerId: element?.bill_customer_id,
            division: division,
            executedPrice: element?.adjustedPrice,
            isRecOverrideFlag:
              element?.Avg_peer_Price !== element?.adjustedPrice ? 1 : 0,
            opportunity: element?.opportunity,
            project_flag: element?.project_flag,
            peerGroupName: element?.peerGroupName
          };
          finalData.push(obj);
        });
        console.log(finalData);
      });

      return finalData;
    } else if (isSingle == 3) {
      let obj = {},
        finalData: any = [];
      console.log(customerData?.division, 123);
      data?.tableData.forEach((element: any, index: number) => {
        obj = {
          itemId: element?.itemId,
          customerId: element?.customer,
          division: customerData?.division,
          executedPrice: element?.executedPrice,
          isRecOverrideFlag:
            element?.peerPrice !== element?.executedPrice ? 1 : 0,
          opportunity: element?.opportunity,
          peerGroupName: element?.peerGroupName,
          project_flag: element?.project_flag
        };
        finalData.push(obj);
      });
      return finalData;
    }

    return data;
  };

  prepareRejectData = (
    data: any,
    isSingle: number = 0,
    customerData: any = null
  ) => {
    if (isSingle == 0) {
      let finalData = [data];
      if (finalData?.length !== 0) {
        finalData.forEach((element: any, index: number) => {
          element.isRecOverrideFlag =
            element?.executedPrice !== element?.peerPrice ? 1 : 0;
        });

        return finalData;
      }
    } else if (isSingle == 1) {
      let obj = {},
        finalData: any = [];

      data?.data.forEach((element: any, index: number) => {
        obj = {
          itemId: element?.itemId,
          customerId: element?.bill_customer_id,
          division: data?.division,
          project_flag: element?.project_flag,
          peerGroupName: element?.peerGroupName
        };
        finalData.push(obj);
      });

      return finalData;
    } else if (isSingle == 2) {
      let obj = {},
        finalData: any = [];

      data?.data?.divisionList.forEach((d: any) => {
        let division = d?.id;
        d?.list.forEach((element: any) => {
          obj = {
            itemId: element?.itemId,
            customerId: element?.bill_customer_id,
            division: division,
            project_flag: element?.project_flag,
            peerGroupName: element?.peerGroupName
          };
          finalData.push(obj);
        });
        console.log(finalData);
      });

      return finalData;
    } else if (isSingle == 3) {
      let obj = {},
        finalData: any = [];
      console.log(customerData?.division, 123);
      data?.tableData.forEach((element: any, index: number) => {
        obj = {
          itemId: element?.itemId,
          customerId: element?.customer,
          division: customerData?.division,
          executedPrice: element?.executedPrice,
          isRecOverrideFlag:
            element?.peerPrice !== element?.executedPrice ? 1 : 0,
          opportunity: element?.opportunity,
          project_flag: element?.project_flag,
          peerGroupName: element?.peerGroupName
        };
        finalData.push(obj);
      });
      return finalData;
    }

    return data;
  };

  updateExecutedPriceData = (
    data: any,
    isSingle: number = 0,
    customerData: any = null
  ) => {
    if (data && !this.state.updateExpectedPriceDisable) {
      console.log(customerData, "cust");
      this.setState({
        updateExpectedPriceDisable: true,
      });
      updateExecutedPrice({
        data: this.prepareUpdateData(data, isSingle, customerData),
      })
        .then((response: any) => {
          if (response.status === 200) {
            this.getCustomerList(10, 1, "desc", "opportunity", undefined, undefined, {}, false);
            this.getTotalCountOfRecords(-1, 0);
            if (customerData) {
              this.handleTableDivClick({
                id: customerData?.division,
                customerId: customerData?.customer,
                name: customerData?.name,
              });
            }
          }
          this.setState({
            updateExpectedPriceDisable: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            updateExpectedPriceDisable: false,
          });
        });
    }
  };

  rejectExecutedPriceData = (
    data: any,
    isSingle: number = 0,
    customerData: any = null
  ) => {
    if (data && !this.state.rejectExpectedPriceDisable) {
      console.log(customerData, "cust");
      this.setState({
        rejectExpectedPriceDisable: true,
      });
      rejectExecutedPrice({
        data: this.prepareRejectData(data, isSingle, customerData),
        userEmail: this.state.userEmail
      })
        .then((response: any) => {
          if (response.status === 200) {
            this.getCustomerList(10, 1, "desc", "opportunity", undefined, undefined, {}, false);
            this.getTotalCountOfRecords(-1, 0);
            if (customerData) {
              this.handleTableDivClick({
                id: customerData?.division,
                customerId: customerData?.customer,
                name: customerData?.name,
              });
            }
          }
          this.setState({
            rejectExpectedPriceDisable: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            rejectExpectedPriceDisable: false,
          });
        });
    }
  };

  handleFilterChange = (data: any) => {
    this.setState({ filter: data, scatterData: null });
    this.getCustomerList(
      10,
      1,
      "desc",
      "opportunity",
      this.state.sliderValues[0],
      this.state.sliderValues[1],
      data
    );
    this.getTotalCountOfRecords(this.state.sliderValues[1], this.state.sliderValues[0], data);
  };

  render() {
    const {
      powerBiSelectedCustomer,
      tableData,
      divsionTableSUmmaryData,
      pageLoading,
      enableSave,
      tableHeight,
      openPopUp,
      openTrendPopUp,
      historicalTrendData,
      selectedCustomerData,
      scatterData,
      minYAxis,
      maxYAxis,
      recommendationAction,
      divisionFilter,
      tempDivisionFilter,
      selectedCustomerDataDivison,
      divison,
      pageNumber,
      pageSize
    } = this.state;

    let graphCount: any;
    // if (scatterData) {
    //   graphCount = Object.values(scatterData.l4AvgPrice).length;
    //   mdForScatter = Math.floor(21 / graphCount);
    // }

    const scatterLocal = scatterData;

    return (
      <>
        {
          // pageLoading && <div className="loaderCustom"></div>
          pageLoading && (
            <Loader
              style={{ zIndex: 9999 }}
              size="md"
              speed="slow"
              inverse
              backdrop
              center
              content=""
            />
          )
        }
        {/* {openPopUp && (
              <div className="modalBCI">
                <div className="modalBCI-content">
                  <span className="closeBCI" onClick={this.handleClose}>
                    &times;
                  </span>
                  <div style={{ textAlign: "center" }}>
                    <span style={{ color: "white", fontSize: "1.3vw" }}>
                      Type your reasons
                    </span>
                  </div>
                  <table>
                    <tbody>
                      <tr>
                        <th style={{ color: "white" }}>Item Id</th>
                        <th style={{ color: "white" }}>Division</th>
                        <th style={{ color: "white" }}>Reason</th>
                      </tr>
                      {this.nrData &&
                        this.nrData.map((d: any) => (
                          <tr>
                            <td
                              style={{
                                color: "white",
                                backgroundColor: "#353535",
                              }}
                            >
                              {d.itemId}
                            </td>
                            <td style={{ color: "white" }}>{d.division}</td>
                            <td style={{ color: "white" }}>
                              <input
                                style={{ color: "black" }}
                                onChange={(e) => (d.reason = e.target.value)}
                                type="text"
                                placeholder="Type the reason here"
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <div className="divModal">
                    <Button
                      className="buttonMargin"
                      style={{
                        color: "grey",
                        fontSize: "0.7vw",
                        marginRight: "2%",
                      }}
                      onClick={() => this.handleClose()}
                      appearance="default"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="buttonMargin"
                      color="green"
                      style={{ color: "white", fontSize: "0.7vw" }}
                      onClick={() => this.saveReason()}
                      appearance="default"
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            )} */}

        {/* {openTrendPopUp && (
              <div className="modalBCI trendmodalBCI">
                <div
                  id="trendcontent"
                  className="modalBCI-content trendPopUpContent"
                >
                  <span className="closeBCI" onClick={this.handleClose}>
                    &times;
                  </span>
                  {historicalTrendData && (
                    <span
                      style={{
                        color: "#ffffff",
                        fontSize: "1.1vw",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        columnGap: "2%",
                      }}
                    >
                      Monthly Price trend for L4 -{" "}
                      {Object.keys(scatterData.l4RecommPrice)[0]} and Division{" "}
                      {scatterData ? (
                        <span
                          style={{
                            width: "24%",
                            fontSize: "0.85vw",
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          <SelectPicker
                            searchable={false}
                            preventOverflow={true}
                            appearance="default"
                            size="xs"
                            onChange={(value: any) =>
                              this.tempDivChange(
                                value,
                                scatterData,
                                selectedCustomerData
                              )
                            }
                            menuStyle={{
                              background: "gray",
                              color: "white",
                              width: "100px",
                              fontSize: "1em",
                              zIndex: "9999",
                            }}
                            placeholder={
                              tempDivisionFilter.length
                                ? "Division " + tempDivisionFilter[0]
                                : "All"
                            }
                            data={scatterData?.actualDivisionId?.map(
                              (a: any) => {
                                return {
                                  label: "Division " + a.division,
                                  value: a.division,
                                };
                              }
                            )}
                            value={
                              tempDivisionFilter.length
                                ? tempDivisionFilter[0]
                                : "All"
                            }
                            renderMenuItem={(label: any) => {
                              return (
                                <div title={label}>
                                  <i /> {label}
                                </div>
                              );
                            }}
                            style={{
                              width: "58%",
                              background: "gray",
                              color: "white",
                            }}
                          />
                        </span>
                      ) : null}
                    </span>
                  )}
                  <Row>
                    <MonthlyTrendGraph
                      data={historicalTrendData}
                    ></MonthlyTrendGraph>
                  </Row>
                </div>
              </div>
            )} */}

        <div className="pricingComp">
          <Title
            isGoBackLinkVisible={this.state.isGoBackLinkVisible}
            setGoBackLinkValue={this.setGoBackLinkValue}
            powerBiSelectedCustomer={powerBiSelectedCustomer}
          />

          <Filters
            handleSliderAPI={this.handleSliderAPI}
            data={tableData}
            handleFilterChange={this.handleFilterChange}
          />


          <Row style={{ lineHeight: "0.6 !important" }} className="show-grid">
            <Col xs={24} sm={24} md={1}></Col>
            <Col className="subHead" xs={24} sm={24} md={11}>
              {
                "Customer Summary ( " +
                (this.state.totalCustomers === undefined
                  ? 0
                  : this.thousands(this.state.totalCustomers)) +
                " Customers, $" +
                numberFormatter(this.state.totalOpportunity, 0) +
                " Opportunity )"
                // (Math.round(
                //   Math.round((this.state.totalOpportunity / 1.0e6) * 10) /
                //     10
                // )
                //   .toString()
                //   .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") +
                //   "M Opportunity)")
              }
            </Col>

            {/* <Col xs={24} sm={24} md={2}>
              <div style={{ paddingBottom: "5px" }}>
                {this.state.pricingFilterData?.length !== 0 ? (
                  <Filter
                    data={this.state.pricingFilterData}
                    handleChange={this.handleFilterSelection}
                  ></Filter>
                ) : (
                  ""
                )}
              </div>
            </Col> */}
            <Col xs={24} sm={24} md={1} />
            <Col
              xs={24}
              sm={24}
              md={10}
              // md={selectedCustomerData && scatterData ? 5 : 11}
              className="subHeadRHS"
            >
              <span
                style={{
                  width: "50%",
                }}
              >
                Customer Pricing and Opportunity
              </span>
            </Col>
            <Col xs={24} sm={24} md={1} />

            <Col xs={24} sm={24} md={1} />
          </Row>
          <Row className="show-grid">
            <Col xs={24} sm={24} md={1}></Col>
            <Col
              className="greenBorder"
              style={{ height: "58vh" }}
              xs={24}
              sm={24}
              md={11}
            >
              {tableData?.list?.length > 0 && (
                <Table
                  // selectedPC={this.state.selectedPC}
                  powerBiSelectedCustomer={powerBiSelectedCustomer}
                  handleBCISubmit={this.handleBCISubmit}
                  handleModify={this.handleModify}
                  handleRecReject={this.rejectExecutedPriceData}
                  handleRecAccept={this.updateExecutedPriceData}
                  handleRecChanges={this.handleRecChanges}
                  handleReset={this.handleReset}
                  sortObj={this.sortObj}
                  sortFn={this.sortFnLocal}
                  enableSave={enableSave}
                  handleSave={this.handleSubmit}
                  data={tableData}
                  handleRowClick={this.wrapperHandleTableRowClick}
                  handleRuleChange={this.handleRuleChange}
                  recommendationAction={recommendationAction}
                  divisionFilter={divisionFilter}
                  selectedCustomerData={selectedCustomerData}
                  handlePaginationAPI={this.handlePaginationAPI}
                  totalPages={this.state.totalCustomers}
                  setPayloadVariables={this.setPayloadVariables}
                  pageNumber={pageNumber}
                  pageSize={pageSize}
                  handlePriceChange={(
                    exec: any,
                    current: number,
                    selectedRow: any,
                    highlightedItemId: number
                  ) =>
                    this.handleExecPriceInTable(
                      exec,
                      current,
                      selectedRow,
                      highlightedItemId
                    )
                  }
                />
              )}
            </Col>
            <Col xs={24} sm={24} md={1}></Col>
            {!divison && (
              <Col style={{ height: "58vh" }} xs={24} sm={24} md={10}>
                <Row
                  style={{ fontSize: "0.69vw" }}
                  className="show-grid greenBorder"
                >
                  {selectedCustomerData && scatterData ? (
                    <>
                      <Col style={{ color: "#ffffff" }} xs={24} sm={24} md={15}>
                        Customer:&nbsp;{selectedCustomerData.name}{" "}
                        {/* {selectedCustomerData.customerDesc} */}
                      </Col>
                      <Col style={{ color: "#ffffff" }} xs={24} sm={24} md={9}>
                        Volume:{" "}
                        {
                          Number(scatterData.summaryData.volume).toLocaleString()
                        } Units Per Year
                      </Col>
                      <Col style={{ color: "#ffffff" }} xs={24} sm={24} md={15}>
                        Revenue: $
                        {numberFormatter(
                          Number(scatterData.summaryData.revenue)
                        )} Per Year
                      </Col>
                      <Col style={{ color: "#ffffff" }} xs={24} sm={24} md={9}>
                        Opportunity  at Target Price: $
                        {numberFormatter(
                          this.state.scatterSummaryCopy.opportunity
                        )} Per Year
                      </Col>
                    </>
                  ) : (
                    <span
                      style={{ lineHeight: "20px" }}
                      className="divTextCenter"
                    >
                      Click on the left Table to get the Detailed view
                    </span>
                  )}
                </Row>
                <Row style={{ height: "1%" }} className="show-grid">
                  <Col xs={24} sm={24} md={24}></Col>
                </Row>
                <Row
                  style={{ height: "51vh" }}
                  className="show-grid greenBorder"
                >
                  {scatterData ? (
                    <>
                      <Row
                        style={{
                          height: "5%",
                          position: "relative",
                        }}
                        className="show-grid"
                      >
                        <Col style={{ width: "12%" }} xs={24} sm={24} md={1} />
                        <Col
                          className="graphTitle"
                          xs={24}
                          sm={24}
                          md={23}
                          style={{ fontSize: "1vw" }}
                        >
                          Price Comparison by Customers
                        </Col>
                      </Row>

                    </>
                  ) : <span className="divTextCenter">
                    Click on the left Table to get the Detailed view
                  </span>}
                  {
                    scatterData && (<Row
                      style={{
                        height: "5%",
                        position: "relative",
                        top: "15px",
                      }}
                      className="show-grid"
                    >
                      <Col
                        className="graphTitle"
                        xs={24}
                        sm={24}
                        md={23}
                        style={{ width: "88%", fontSize: "2vh", marginBottom: "3vh", display: "flex", paddingLeft: "1vw", alignItems: "center" }}
                      >
                        <span style={{
                          color: "#289c45", fontSize: "1vw",
                          paddingRight: "5px"
                        }}>╍╍╍</span>5th percentile
                        <span style={{
                          color: "#3a7048", paddingLeft: "5px", fontSize: "1vw",
                          paddingRight: "5px"
                        }}>---</span>25th percentile
                        <span style={{
                          color: "#344d3a", paddingLeft: "5px", fontSize: "1vw",
                          paddingRight: "5px", fontWeight: '800'
                        }}>——</span>50th percentile
                        <span style={{
                          color: "rgba(255, 99, 132, 0.5)", paddingLeft: "5px", fontSize: "1vw",
                          paddingRight: "5px"
                        }}>---</span>Target Price
                      </Col>
                      <Col style={{ width: "12%" }} xs={24} sm={24} md={1} />

                    </Row>)
                  }
                  <Row style={{ height: "90%" }} className="show-grid">
                    {scatterData &&
                      Object.values(scatterLocal.l4AvgPrice)
                        .sort(
                          (a: any, b: any) =>
                            b[0].opportunity - a[0].opportunity
                        )
                        .map((d: any, index: number) => {
                          return (
                            <Col
                              style={{
                                height: "100%",
                                paddingLeft: "0px !important",
                                paddingRight: "0px !important",
                                width:
                                  ((document.getElementById("rowGraph")
                                    ?.offsetWidth || 0) -
                                    (document.getElementById("customerGraphId")
                                      ?.offsetWidth || 0)) /
                                  graphCount -
                                  1,
                              }}
                              xs={24}
                              sm={24}
                              md={24}
                            >
                              <Row style={{ height: "100%" }}>
                                <Col
                                  xs={12}
                                  sm={12}
                                  md={12}
                                >

                                  <BubbleScatterWithZoom
                                    label={"Vol/Drop"}
                                    data={d}
                                    graphWidth={window.innerWidth - 275}
                                    graphHeight={window.innerHeight - 275}
                                    minYAxis={minYAxis}
                                    maxYAxis={maxYAxis}
                                    selectedCustomerData={selectedCustomerData}
                                    openPopup={this.state.openPopup}
                                    referenceLine={
                                      scatterData.summaryData.executedPrice
                                    }
                                    tableHeight={"30vh"}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  sm={12}
                                  md={12}
                                >
                                  {scatterData ? (
                                    <DivisionWiseTable
                                      height={"100%"}
                                      scatterData={scatterData}
                                      itemExecPrice={this.state.itemExecPrice}
                                      itemId={this.state.itemId}
                                      selectedCustomerData={selectedCustomerData}
                                      summaryData={divsionTableSUmmaryData}
                                      recommendationAction={recommendationAction}
                                      handleAcceptFromCustomerSelect={
                                        this.updateExecutedPriceData
                                      }
                                      handleExecutionPriceChange={
                                        this.handleExecutionPriceChange
                                      }
                                      handleSubmit={
                                        this.handleExecPriceChangeSubmit
                                      }
                                      handleExportPricingReport={
                                        this.handleExportPricingReport
                                      }
                                    />
                                  ) : (
                                    <span className="divTextCenter">
                                      Click on the left Table to get the Detailed
                                      view
                                    </span>
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          );
                        })}
                  </Row>
                </Row>
                <Row style={{ height: "1%" }} className="show-grid">
                  <Col xs={24} sm={24} md={24}></Col>
                </Row>
                {/* <Row
                  style={{ height: "38%" }}
                  className="show-grid greenBorder"
                >
                  {scatterData ? (
                    <DivisionWiseTable
                      height={"100%"}
                      scatterData={scatterData}
                      itemExecPrice={this.state.itemExecPrice}
                      itemId={this.state.itemId}
                      selectedCustomerData={selectedCustomerData}
                      summaryData={divsionTableSUmmaryData}
                      recommendationAction={recommendationAction}
                      handleAcceptFromCustomerSelect={
                        this.updateExecutedPriceData
                      }
                      handleExecutionPriceChange={
                        this.handleExecutionPriceChange
                      }
                      handleSubmit={this.handleExecPriceChangeSubmit}
                      handleExportPricingReport={this.handleExportPricingReport}
                    />
                  ) : (
                    <span className="divTextCenter">
                      Click on the left Table to get the Detailed view
                    </span>
                  )}
                </Row> */}
              </Col>
            )}
            {divison && (
              <DivisionData
                tableHeight={"58vh"}
                minYAxis={minYAxis}
                maxYAxis={maxYAxis}
                scatterData={scatterData}
                selectedCustomerData={selectedCustomerDataDivison}
                recommendationAction={recommendationAction}
                handleExecutionPriceChange={this.handleExecutionPriceChangeTop5}
                handleRejectFromCustomerSelect={this.rejectExecutedPriceData}
                handleAcceptFromCustomerSelect={this.updateExecutedPriceData}
              />
            )}
            <Col xs={24} sm={24} md={1}></Col>
          </Row>

          {this.state.openPopup && (
            <Modal open={this.state.openPopup}>
              <Box
                className="modalClass greenBorder"
                style={{
                  width: window.innerWidth - 75,
                  height: window.innerHeight - 100,
                }}
              >
                <Row className="show-grid" style={{ height: "100%" }}>
                  <Row style={{ height: "5%" }} className="show-grid">
                    <Col style={{ height: "100%" }} xs={24} sm={24} md={24}>
                      <div
                        style={{ height: "100%", fontSize: "15px" }}
                        className="legendDiv"
                      >
                        <span
                          className="dot"
                          style={{
                            backgroundColor:
                              selectedCustomerData?.Customer_Class === "NA"
                                ? "#d3d3d3"
                                : "yellow",
                            height: "80%",
                            width: "1.5%",
                          }}
                        ></span>
                        <label style={{ paddingRight: "10px" }}>
                          {selectedCustomerData?.Customer_Class === "NA"
                            ? "Peer Set"
                            : "Customer Class Peer Set"}
                        </label>
                        <span className="expectedPriceLegend">-----</span>
                        <label>Peer Weighted Average Price</label>
                        <span
                          className="dot"
                          style={{
                            backgroundColor: "#a4f504",
                            height: "80%",
                            width: "1.5%",
                          }}
                        ></span>
                        <label style={{ marginRight: "4%" }}>
                          Current Price
                        </label>
                        <div className="maximize" style={{ right: "1%" }}>
                          <i
                            className={
                              this.state.openPopup
                                ? "fa fa-compress"
                                : "fa fa-expand"
                            }
                            style={{
                              color: "white",
                              fontSize: "1.2vw",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              this.handleToggle(!this.state.openPopup)
                            }
                          ></i>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row
                    style={{
                      height: "5%",
                      position: "relative",
                    }}
                    className="show-grid"
                  >
                    <Col style={{ width: "5%" }} xs={24} sm={24} md={24} />
                    <Col
                      className="graphTitle"
                      xs={24}
                      sm={24}
                      md={24}
                      style={{ width: "95%", fontSize: "2vw" }}
                    >
                      Price comparison by Customers
                    </Col>
                  </Row>

                  <Row className="show-grid">
                    {scatterData &&
                      Object.values(scatterLocal.l4AvgPrice)
                        .sort(
                          (a: any, b: any) =>
                            b[0].opportunity - a[0].opportunity
                        )
                        .map((d: any, index: number) => (
                          <Col
                            style={{
                              height: "100%",
                              paddingLeft: "0px !important",
                              paddingRight: "0px !important",
                              width:
                                ((document.getElementById("rowGraph")
                                  ?.offsetWidth || 0) -
                                  (document.getElementById("customerGraphId")
                                    ?.offsetWidth || 0)) /
                                graphCount -
                                1,
                            }}
                            xs={24}
                            sm={24}
                            md={24}
                          >
                            <Row style={{ height: "70%" }}>
                              <BubbleScatterWithZoom
                                label={"Vol/Drop"}
                                data={d}
                                graphWidth={window.innerWidth - 275}
                                graphHeight={window.innerHeight - 275}
                                minYAxis={minYAxis}
                                maxYAxis={maxYAxis}
                                openPopup={this.state.openPopup}
                                selectedCustomerData={selectedCustomerData}
                                referenceLine={
                                  scatterData.summaryData.l4RecommPrice
                                }
                              />
                            </Row>
                            <Row
                              style={{
                                position: "relative",
                                bottom: "10px",
                                textAlign: "center",
                                left: "18%",
                                width: "80%",
                              }}
                            >
                              <span className="l4Title">
                                Item ID - {this.state.itemId}
                              </span>
                              <div
                                className="l4Title"
                                style={{ marginBottom: "10px" }}
                              >
                                Item Description - {this.state.itemDesc}
                              </div>
                            </Row>
                          </Col>
                        ))}
                  </Row>
                </Row>
              </Box>
            </Modal>
          )}
        </div>
      </>
    );
  }
}
